import { createSelector } from 'reselect';
import get from 'lodash/get';

const trovitState = state => state.trovit;

export const getTrovitUrl = state => trovitState(state).url;
export const getAbTest = state => trovitState(state).abTest;
export const getTrovitPageViewId = state => trovitState(state).pageviewId;
export const getPublishYourCvUrl = state => get(trovitState(state), ['publishYourCv', 'landing']);
export const publishYourCvSourceNameSelector = state =>
  get(trovitState(state), ['publishYourCv', 'sourceName'], '');
export const getPublishYourCvSourceId = state =>
  get(trovitState(state), ['publishYourCv', 'sourceId']);
export const getPublishYourCvSourceImage = state =>
  get(trovitState(state), ['publishYourCv', 'image']);
export const getQuery = state => trovitState(state).query;
export const getUserIp = state => trovitState(state).userIp;
export const getUserAgent = state => trovitState(state).userAgent;
export const getOrigin = state => trovitState(state).origin;
export const getTrackingCodes = state => trovitState(state).trackingCodes;

export const trovitSelector = createSelector(
  trovitState,
  trovit => trovit
);

export const installationIdSelector = createSelector(
  trovitState,
  trovit => trovit.installationId
);



// WEBPACK FOOTER //
// ./app/common/selectors/trovit.js